import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=4746816e&scoped=true&"
import script from "./SingleVideo.vue?vue&type=script&lang=js&"
export * from "./SingleVideo.vue?vue&type=script&lang=js&"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=4746816e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746816e",
  null
  
)

export default component.exports